import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IRespose } from '../interface/response.model';
import { environment } from 'environments/environment';
import { Observable, catchError, lastValueFrom, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private API: string = `${environment.apiSimpleLaundry}`
  public user: any = null;

  constructor(private router: Router, private toastr: ToastrService, private http: HttpClient) { }

  public postLogin(request: any): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .post<IRespose<any>>(`${this.API}/auth/login`, request)
      .pipe(
        map(res => {
          return res.data
        }),
        catchError(this.handleError)
      ));
  }

  public getProfile(): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .get<IRespose<any>>(`${this.API}/auth/getProfile`)
      .pipe(
        /* map(res => {
          return res.data.user
        }), */
        catchError(this.handleError)
      ));
  }

  private handleError(e: any) {
    console.error('An error occurred', JSON.stringify(e)); // for demo purposes only
    return throwError(() => new Error(e.error.message));
  }
}
